import { apiGet } from "shared/services/apiRequest";
import { buildQueryString } from "shared/services/utils";

export const getTelemetryService = async (data) =>
    apiGet(`/reports/telemetry?${buildQueryString({
        deviceIds: data.deviceIds,
        start_date: data.startDate,
        end_date: data.endDate,
        category: data.category,
    })}`);

export const getDataConsumptionService = async (data) =>
    apiGet(`/reports/data-consumption?${buildQueryString({
        inhand_ids: data.inhandIds,
        start_date: data.startDate,
        end_date: data.endDate,
    })}`);




export const getDataConsumptionPdfService = async (data) =>
    apiGet(`/pdf/data-consumption/view?${buildQueryString({
        deviceIds: data.deviceIds,
        inhand_ids: data.inhandIds,
        start_date: data.startDate,
        end_date: data.endDate,
        type: data.type,
    })}`, { responseType: 'blob' });
